import classNames from 'classnames'
import React from 'react'

import Footer from './Footer'
import Header from '../culdesacTempe3/Header'

interface LayoutProps {
  children?: React.ReactNode
  className?: string
  showFooter?: boolean
  showNavbarCTA?: boolean
  unmaskPageInDatadog?: boolean
}

/**
 * The site layout for pages on Culdesac's main site.
 * @returns JSX to render the site layout w/ children contained within.
 */
const Layout: React.FC<LayoutProps> = ({
  children,
  className,
  showFooter = true,
  showNavbarCTA = true,
  unmaskPageInDatadog: unmaskPageInDatadog = false,
}) => (
  <span className={classNames('new-design', unmaskPageInDatadog && 'dd-privacy-allow', className)}>
    <section className="relative bg-[#5AA1D1] text-white py-4 px-2 md:py-0 md:px-0">
      <div className="mx-auto relative z-10">
        <Header isHero={false} />
      </div>
    </section>
    {children}
    {showFooter && <Footer />}
  </span>
)

export default Layout
